import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component/app.component';
import { TopBarComponent } from './infrastructure/menu/top-bar/top-bar.component';
// import { LeaguesListComponent } from './modules/leagues-list/leagues-list.component';
import { BasicService } from './modules/common/basic.service';
import { CouponComponent } from './modules/betting/coupon/coupon.component';
import { HttpClientModule } from '@angular/common/http';
// import { FixturesComponent } from './modules/fixtures/fixtures.component';
// import { OddsComponent } from './modules/betting/odds/odds.component';
import { CouponService } from './modules/betting/common/coupon.service';
import { FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { MatCardModule } from '@angular/material/card';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { A11yModule } from '@angular/cdk/a11y';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TournamentTableComponent } from './modules/tournamentParticipation/tournamentTable/tournamentTable.component';
import { InPlayComponent } from './modules/betting/in-play/in-play.component';
import { ConfigService } from './infrastructure/config.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from './infrastructure/network/interceptor.service';
import { InterceptorInputService } from './infrastructure/network/interceptor-input.service';
import { OddsService } from './modules/betting/common/odds.service';
import { InPlayService } from './modules/betting/in-play/in-play.service';
import { TournamentService } from './modules/tournamentsSetup/tournament.service';
import { LoginComponent } from './modules/navigation/login/login.component';
import { RegisterComponent } from './modules/navigation/register/register.component';
import { TournamentsListComponent } from './modules/tournamentParticipation/tournaments-list/tournaments-list.component';
import 'zone.js/dist/zone';
import { CalendarComponent } from './modules/tournamentsSetup/calendar/calendar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FlatpickrModule } from 'angularx-flatpickr';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { CalendarService } from './modules/tournamentsSetup/common/calendar.service';
import { TurnSetupComponent } from './modules/tournamentsSetup/turn-setup/turn-setup.component';
import { TournamentSetupComponent } from './modules/tournamentsSetup/tournament-setup/tournament-setup.component';
import { TournamentsFixturesComponent } from './modules/tournamentParticipation/tournaments-fixtures/tournaments-fixtures.component';
import { TournamentsTurnsComponent } from './modules/tournamentParticipation/tournaments-turns/tournaments-turns.component';
import { TournamentsOddsComponent } from './modules/tournamentParticipation/tournaments-odds/tournaments-odds.component';
import { TopBarTournamentComponent } from './infrastructure/menu/top-bar-tournament/top-bar-tournament.component';
import { BreadcrumbModule } from "xng-breadcrumb";
import { BreadcrumbService } from 'xng-breadcrumb';
import { UserCouponsComponent } from './modules/tournamentParticipation/user-coupons/user-coupons.component';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { CountdownModule } from 'ngx-countdown';
import { ChangePasswordComponent } from './modules/navigation/change-password/change-password.component';
import { ChangeOtherUserPasswordComponent } from './modules/navigation/change-other-user-password/change-other-user-password.component';
import { MyTournamentsComponent } from './modules/tournamentParticipation/my-tournaments/my-tournaments.component';
import { TournamentManagerComponent } from './modules/tournamentsSetup/tournament-manager/tournament-manager.component';
import { UsersTableComponent } from './modules/navigation/users-table/users-table.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CancelFixtureComponent } from './modules/tournamentsSetup/cancel-fixture/cancel-fixture.component';

@NgModule({

    imports: [
        NgxMatNativeDateModule,
        CountdownModule,
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        MatDatepickerModule,
        MatInputModule,
        NgxMatTimepickerModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        NgxMatDatetimePickerModule,
        BreadcrumbModule,
        CommonModule,
        FormsModule,
        NgbModalModule,
        FlatpickrModule.forRoot(),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        NgbModule,
        MatListModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        MatNativeDateModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatButtonModule,
        MatIconModule,
        MatDividerModule,
        MatFormFieldModule,
        MatTabsModule,
        MatDialogModule,
        MatInputModule,
        MatSliderModule,
        MatCardModule,
        CdkScrollableModule,
        A11yModule,
        ClipboardModule,
        CdkStepperModule,
        CdkTableModule,
        CdkTreeModule,
        DragDropModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatStepperModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        PortalModule,
        ScrollingModule,
        BrowserModule,
        HttpClientModule,
        ReactiveFormsModule,
        RouterModule.forRoot([
            { path: 'oddsee/register', component: RegisterComponent },
            { path: '', component: LoginComponent },
            { path: 'oddsee/tournaments', component: TournamentsListComponent },
            { path: 'oddsee/mytournaments', component: MyTournamentsComponent },
            { path: 'oddsee/tournaments/:tournamentId/table', component: TournamentTableComponent },
            { path: 'oddsee/inplay', component: InPlayComponent },
            { path: 'oddsee/coupon', component: CouponComponent },
            { path: 'oddsee/calendar', component: CalendarComponent },
            { path: 'oddsee/tournaments/:tournamentId', component: TournamentsTurnsComponent },
            { path: 'oddsee/tournaments/:tournamentId/turn/:turnId', component: TournamentsFixturesComponent },
            { path: 'oddsee/tournaments/:tournamentId/turn/:turnId/odds/:fixtureId', component: TournamentsOddsComponent },
            { path: 'oddsee/tournaments/:tournamentId/user/:userId', component: UserCouponsComponent },
            { path: 'oddsee/changepassword', component: ChangePasswordComponent },
            { path: 'oddsee/change-other-user-password', component: ChangeOtherUserPasswordComponent },
            { path: 'oddsee/tournament-manager', component: TournamentManagerComponent },
            { path: 'oddsee/users-table', component: UsersTableComponent },
            { path: 'oddsee/cancel-fixture', component: CancelFixtureComponent },
        ], { relativeLinkResolution: 'legacy' }),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),

    ],
    declarations: [
        AppComponent,
        TopBarComponent,
        CouponComponent,
        TournamentTableComponent,
        InPlayComponent,
        LoginComponent,
        RegisterComponent,
        TournamentsListComponent,
        CalendarComponent,
        TurnSetupComponent,
        TournamentSetupComponent,
        TournamentsFixturesComponent,
        TournamentsTurnsComponent,
        TournamentsOddsComponent,
        TopBarTournamentComponent,
        UserCouponsComponent,
        ChangePasswordComponent,
        ChangeOtherUserPasswordComponent,
        MyTournamentsComponent,
        TournamentManagerComponent,
        UsersTableComponent,
        CancelFixtureComponent,
    ],
    exports: [
        CalendarComponent,
    ],
    bootstrap: [
        AppComponent,
    ],
    providers: [
        BreadcrumbService,
        BasicService,
        CouponService,
        ConfigService,
        OddsService,
        InPlayService,
        TournamentService,
        CalendarService,
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
        { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorInputService, multi: true },
    ]
})
export class AppModule { }

/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/